import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f1cddbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "SignInForm__logo" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "logo__title" }, "SPARK"),
  /*#__PURE__*/_createElementVNode("p", { class: "logo__secondtitle" }, "Business process management system")
], -1))
const _hoisted_2 = {
  key: 1,
  class: "w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "SignInForm",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSubmit && _ctx.emitSubmit(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    (_ctx.state.is_on_verification)
      ? (_openBlock(), _createBlock(_component_the_input, {
          key: 0,
          value: _ctx.state.email,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.email) = $event)),
          placeholder: "E-mail",
          "is-invalid": _ctx.v$.email.$error,
          "validation-errors": _ctx.v$.email.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_the_input, {
            value: _ctx.state.code,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.code) = $event)),
            placeholder: "Код подтверждения",
            "is-invalid": _ctx.v$.code.$error,
            "validation-errors": _ctx.v$.code.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            value: _ctx.state.newPassword,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.newPassword) = $event)),
            placeholder: "Новый пароль",
            "is-invalid": _ctx.v$.newPassword.$error,
            "validation-errors": _ctx.v$.newPassword.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"])
        ])),
    _createVNode(_component_the_button, {
      type: "submit",
      loading: _ctx.loading || _ctx.state.is_loading,
      class: "primary medium mt-6"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.state.is_on_verification ? 'Отправить код' : 'Сменить пароль'), 1)
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_the_button, {
      onClick: _ctx.emitCancel,
      loading: _ctx.loading,
      class: "text medium"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Назад ")
      ]),
      _: 1
    }, 8, ["onClick", "loading"])
  ], 32))
}